// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { HotTag } from '../../styled-components/shared';

const Wrapper = styled.div`
  display: flex;
  gap: 0.2em;
  justify-content: center;
  align-items: center;
`;

const StyledHotTag = styled(HotTag)`
  font-size: 0.9em;
  padding-top: 0;
  padding-bottom: 0;
`;

const HotNumber = styled.div`
  color: rgb(140, 140, 140);
  padding-bottom: 0.1em;
`;

type MatchBetHotFilterContentProps = {
  className?: string;
  nbHotBets: number;
};

const MatchBetHotFilterContent = ({ className = '', nbHotBets }: MatchBetHotFilterContentProps) => {
  return (
    <Wrapper className={className}>
      <StyledHotTag>HOT</StyledHotTag>
      <HotNumber>({nbHotBets})</HotNumber>
    </Wrapper>
  );
};

export default React.memo<unknown>(MatchBetHotFilterContent);
